module.exports = __webpack_public_path__ + "static/_05-b01e400b4d7649c866fdf9660ef4f552.jpg";